<template>
  <v-card flat class="pa-4">
    <v-container xclass="py-0" fluid>
      <v-row dense>
        <v-col cols="7">
          <v-tooltip bottom nudge-top="20" open-delay="2000">
            <template v-slot:activator="{on}">
              <v-combobox label="Date format" v-model="settings.dateFormat" :rules="[fieldRules.required]" outlined dense v-on="on"
                          :items="['yyyy-MM-dd','dd/MM/yy','dd/MM/yyyy','MM/dd/yy','MM/dd/yyyy','dd-MMM-yyyy','MMM d, yyyy']"
                          persistent-hint :hint="'ex. ' + formatDate(settings.dateFormat)">
                <template v-slot:item="{item}">
                  <v-list-item-content>{{item}}</v-list-item-content>
                  <v-list-item-action class="text-caption">{{today | formatDate(item)}}</v-list-item-action>
                </template>
              </v-combobox>
            </template>
            <div>Year: yy (e.g. 20), yyyy (e.g. 2021)</div>
            <div>Month: M (e.g. 1), MM (e.g. 01), MMM (e.g. Jan), MMMM (e.g. January)</div>
            <div>Day: d (e.g. 1), dd (e.g. 01)</div>
          </v-tooltip>
        </v-col>
        <v-col cols="5">
          <v-tooltip bottom nudge-top="20" open-delay="2000">
            <template v-slot:activator="{on}">
              <v-combobox label="Time format" v-model="settings.timeFormat" :rules="[fieldRules.required]" outlined dense v-on="on"
                          :items="['h:mm aaa', 'hh:mm a', 'HH:mm']"
                          persistent-hint :hint="'ex. ' + formatDate(settings.timeFormat)">
                <template v-slot:item="{item}">
                  <v-list-item-content>{{item}}</v-list-item-content>
                  <v-list-item-action class="text-caption">{{today | formatDate(item)}}</v-list-item-action>
                </template>
              </v-combobox>
            </template>
            <div>Hour (1-12): h (e.g. 9), yy (e.g. 09) </div>
            <div>Hour (0-23): H (e.g. 9), HH (e.g. 13) </div>
            <div>Minute: m (e.g. 5), mm (e.g. 05)</div>
            <div>AM/PM: a (e.g. AM), aaa (e.g. am), aaaa (e.g. a.m.)</div>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="8">
          <v-select label="Time zone" v-model="settings.timeZone" outlined dense hide-details
                    :items="['Canada/Pacific','Canada/Mountain','Canada/Central','Canada/Eastern','Canada/Atlantic','Canada/Newfoundland','Canada/Yukon']"/>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import {format} from 'date-fns'
import settingsPreferences from '@/views/settings/preferences/settingsPreferences'

export default {
  name: 'SettingsPreferencesGeneralDates',
  mixins: [settingsPreferences],
  data() {
    return {
      today: format(new Date(), 'yyyy-MM-dd HH:mm'),
    }
  },
  methods: {
    formatDate(formatString) {
      return format(new Date(), formatString);
    }
  }
}
</script>